// extracted by mini-css-extract-plugin
module.exports = {"autocomplete":"autocomplete-2vVMN","input":"input-1S4A_"};